export const DEFAULT_APPEARANCE_SETTINGS = {
    accent_color: '#0071d0',
    theme: 'dark',
    columns: 2,
};
//# sourceMappingURL=default-appearance-settings.constants.js.map